import { render, staticRenderFns } from "./MeetingAbout.vue?vue&type=template&id=641e800e&scoped=true"
import script from "./MeetingAbout.vue?vue&type=script&lang=js"
export * from "./MeetingAbout.vue?vue&type=script&lang=js"
import style0 from "./MeetingAbout.vue?vue&type=style&index=0&id=641e800e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641e800e",
  null
  
)

export default component.exports